import { NavLink } from "react-router-dom";
import { useFreshNav } from "@/hooks/useFreshNav";
import { CalendarDays, Columns3, Globe2, ListOrdered, Shield } from "lucide-react";

const TABS = [
  { to: "/", label: "Projections", icon: Columns3, id: "tab-projections", end: true },
  { to: "/today", label: "Game Center", icon: CalendarDays, id: "tab-gamecenter" },
  { to: "/teams", label: "Teams", icon: Shield, id: "tab-teams" },
  { to: "/standings", label: "Standings", icon: ListOrdered, id: "tab-standings" },
  { to: "/europe", label: "Europe", icon: Globe2, id: "tab-europe" },
];

export function MobileTabBar() {
  const fresh = useFreshNav();
  return (
    <nav className="nbc-tabbar" aria-label="Quick navigation" data-testid="mobile-tabbar">
      {TABS.map(({ to, label, icon: Icon, id, end }) => (
        <NavLink key={to} to={to} end={end} onClick={fresh(to)} data-testid={id} className={({ isActive }) => (isActive ? "active" : "")}>
          <Icon size={20} /><span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
